export var IdButtonWithProgressFill;
(function (IdButtonWithProgressFill) {
    IdButtonWithProgressFill["Primary"] = "fill-primary";
    IdButtonWithProgressFill["PrimaryAccent"] = "fill-primary-accent";
})(IdButtonWithProgressFill || (IdButtonWithProgressFill = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/button-with-progress/IdButtonWithProgressFill.ts
// module id = 921
// module chunks = 3